interface PostMessager {
  postMessage(msg: string | any): void
}
interface Webkit {
  messageHandlers: { __iosAppMsgCenter?: PostMessager }
}
declare global {
  interface Window {
    webkit?: Webkit
    Windows?: any
    __androidAppMsgCenter?: PostMessager
    __windowsAppMsgCenter?: PostMessager
    __macAppMsgCenter?: PostMessager
  }
}
export default function (msg, fallbackFunc?: Function): void {
  if (!!window.webkit && !!window.webkit.messageHandlers && !!window.webkit.messageHandlers.__iosAppMsgCenter) {
    window.webkit.messageHandlers.__iosAppMsgCenter.postMessage(msg)
  } else if (window.__androidAppMsgCenter) {
    window.__androidAppMsgCenter.postMessage(JSON.stringify(msg))
  } else if (window.Windows && window.__windowsAppMsgCenter) {
    window.__windowsAppMsgCenter.postMessage(msg)
  } else if (window.__macAppMsgCenter) {
    window.__macAppMsgCenter.postMessage(msg)
  } else if (fallbackFunc) fallbackFunc()
}
